import React, { useEffect, useState } from "react";
import Spinwheel from '../../components/common/Spinwheel';
import { useUserContext } from '../../context/userContext';
import { getProfileApi, getSitesList, switchSite } from '../../utils/ApiEndpointFunctions';

import { toast } from 'react-hot-toast'
import ConfirmationModal from "../../components/modal/ConfirmationModal";
import StatusModal from "../../components/modal/StatusModal";
import { removeToken } from "../../utils/HelperFuncitons";
import './ManageSites.css';

const ManageSites = () => {
  const { userDetails,setUserDetails,langPreference } = useUserContext();
  const recovery = userDetails?.requiresSiteSelection;
  const [loadError, setLoadError] = useState(false);
  const [siteList, setSiteList] = useState([])
  const [loading, setLoading] = useState(true)
  const [confirmMessage,setConfirmMessage] = useState("")
  const [siteId, setSitedId] = useState()
  const confirmModalId = "conFirmModalID"
  const statusModalId = "statusModal"

  const getUserDetails = async () => {
    try {
      const res = await getProfileApi();
      if (res.status === 200) {
        setUserDetails(res?.data.data)
      } else {
        removeToken();
      }
    } catch (error) {
      removeToken();
    }
  }
  const getSites = async () => {
    setLoading(true);
    setLoadError(false);
    try {
      const res = await getSitesList();
      if (res.status === 200) {
        // toast.success(res.data.message);
        setSiteList(res?.data?.data?.userSites)
        setLoading(false)
      }
    } catch (error) {
      setLoadError(true);
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
      setLoading(false)
    }
  }

  useEffect(() => {
    getSites()
  }, [])

  const handleSwitchSite = async () => {
    try {
      const res = await switchSite({ _id: siteId })
      if (res.status === 200) {
        if (recovery) {
          const profile = await getProfileApi();
          const roleType = profile?.data?.data?.roleId?.type || profile?.data?.data?.roleId?.name?.toLowerCase()?.replace(/[^a-z0-9]/g, "");
          window.location.replace(roleType === "inspector" ? "/dlr/report" : "/dashboard");
          return;
        }
        setConfirmMessage(res?.data?.message || "Site Switched Successfully.")
        document.getElementById(confirmModalId).click()
        document.getElementById("statusModalBtn").click()
        getUserDetails()
        getSites()
      }
    } catch (error) {
      console.log(error)
      toast.error("something went wrong");
    }
  }



  return (
    <div className={recovery ? "site-recovery" : undefined}>
      {recovery && <header className="site-recovery__header">
        <div className="site-recovery__header-inner">
          <img className="site-recovery__logo" src="/Group.png" alt="Manage My Site" />
          <div className="site-recovery__account">
            <div className="site-recovery__identity">
              <i className="bi bi-person-circle" aria-hidden="true"></i>
              <span>{[userDetails?.firstName, userDetails?.lastName].filter(Boolean).join(" ")}</span>
            </div>
            <button type="button" className="btn btn-outline-light" onClick={() => { removeToken(); window.location.assign("/"); }}>
              {langPreference?.logout || "Logout"}
            </button>
          </div>
        </div>
      </header>}
      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            <div className="main-content">
              <div className="dash-nav1">
                {!recovery && <div className="back cursor-pointer" onClick={() => { window.history.back() }}><i className="bi bi-chevron-left"></i>{langPreference?.back || "Back"}</div>}
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0 font-blue">{langPreference?.switch_site || "Switch Site"}</h3>
                </div>
                {recovery && !loading && !loadError && <p role="status" className="site-recovery__notice"><i className="bi bi-info-circle" aria-hidden="true"></i><span>{siteList.length
                  ? (langPreference?.site_access_lost || "Your access to the previous site is no longer available. Select another site.")
                  : (langPreference?.no_active_site_access || "No active site access. Contact your administrator.")}</span></p>}
                {loadError && <button className="btn btn-outline-primary" onClick={getSites}>{langPreference?.retry || "Retry"}</button>}
              </div>
              {/* <div className="d-flex justify-content-end align-items-center">
                <div className="d-flex">
                  <nav className="navbar bg-body-tertiary">
                    <form role="search" className="container-fluid">
                      <div className="input-group">
                        <span className="input-group-text" id="basic-addon1"><i className="bi bi-search"></i></span>
                        <input type="text" className="form-control" placeholder="Search Sites" aria-label="Username" aria-describedby="basic-addon1"  />
                      </div>
                    </form>
                  </nav>

                </div>
              </div> */}
              {/* <!-- table --> */}

              {(!recovery || loading || siteList.length > 0) && <div className={recovery ? "site-recovery__table" : undefined}>
              <table className="table d-table mt-4">
                <thead>
                  <tr>
                    <th scope="col">{langPreference?.site_name || "SITE NAME"}</th>
                    <th scope="col">{langPreference?.site_address || "SITE Address"}</th>
                    <th scope="col">{langPreference?.company_name || "COMPANY NAME"}</th>
                    <th scope="col">{recovery ? (langPreference?.action || "Action") : (langPreference?.status || "STATUS")}</th>
                    {/* <th scope="col-2">ACTION</th> */}
                  </tr>
                </thead>
                {
                  loading ?
                    <tbody >
                      <tr>
                        <td colSpan={12}>
                          <div className="d-flex justify-content-center">
                            <Spinwheel />
                          </div>
                        </td>
                      </tr>
                    </tbody> :
                    <>
                      <tbody>

                        {siteList?.length > 0 ? siteList?.map((ele, index) => {
                          return (
                            <tr key={ele._id || index}>
                              {recovery ? <td className="site-recovery__site-name">{ele?.siteData?.name}</td> : <td className= {!ele?.isCurrent ? `text-primary text-decoration-underline cursor-pointer`: "cursor-default"} data-bs-toggle={!ele?.isCurrent ? "modal": ""} data-bs-target={!ele?.isCurrent ? `#${confirmModalId}` : ""} onClick={() => { setSitedId(ele?._id) }}>{ele?.siteData?.name}</td>}
                              <td>{ele?.siteData?.addressId?.address1}</td>
                              <td>{ele?.siteData?.companyId?.name}</td>
                              <td>{recovery ? <button type="button" className="btn btn-primary site-recovery__switch" data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => setSitedId(ele._id)}>
                                {langPreference?.switch_site || "Switch site"}<i className="bi bi-arrow-right" aria-hidden="true"></i>
                              </button> : <button className={`text-capitalize ${ele?.isCurrent ? "approve" : "d-none"}`} style={{ cursor: "default" }}>{ele?.isCurrent ? "Current" : "InActive"}</button>}</td>
                              {/* <td>
                                {!ele?.isCurrent && <div className="dropdown">
                                  <button className="dots dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots-vertical"></i></button>
                                  <ul className="dropdown-menu">
                                    {!ele?.isCurrent && <li className='dropdown-item' data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => { setSitedId(ele?._id) }}>Switch</li>}
                                  </ul>
                                </div>}
                              </td> */}
                            </tr>)
                        }) : <tr className='text-center'>
                          <td colSpan="12">
                            {!recovery && <h1>{langPreference?.data_not_found || "Data Not Found"}</h1>}
                          </td>
                        </tr>}
                      </tbody></>}
              </table>
              </div>}
            </div>
          </div>
        </div>

        <ConfirmationModal modalId={confirmModalId} handleConfirm={handleSwitchSite} message={langPreference?.are_you_sure_to_switch ||  <>Are you sure want to <br /> Switch ?</>} title={langPreference?.switch_site || <>Switch site</>}/>
        <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`} />
        <StatusModal
          modalId={statusModalId}
          message={confirmMessage}
        />

      </div>
    </div>
  )
};

export default ManageSites;
